import { Storage } from "@mui/icons-material";
import {
  Autocomplete,
  CircularProgress,
  Grid2,
  InputAdornment,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { useEffect, useMemo } from "react";
import useUIBp from "../../../Hooks/useUIBoilerplate";
import { useWorker } from "../../../Hooks/useWorker";
import { UIactions } from "../../../store/slices/UI";
import { warehouseActions } from "../../../store/slices/warehouse";
import { workerActions } from "../../../store/slices/workers";
import { humanBytes } from "../../../utility/misc/humanizers";
import { sortObjByKey } from "../../../utility/misc/sortObjByKey";
import { rootsDataId, tunnelTokenId } from "../../Users/Dialogs/RemoteSelection/Actions/getMachineStatus";
import AutoHelp from "../Wrappers/AutoHelp";
import { AutocompleteFilter } from "./utils";

const UIText = {
  "es-CL": {
    normalTxt: "Repositorios",
    loadingTxt: "Cargando repositorios...",
    emptyTxt: "No se encontró repositorios",
    errorTxt: "Error al cargar los repositorios",
  },
  "en-US": {
    normalTxt: "Repositories",
    loadingTxt: "Loading...",
    emptyTxt: "No repositories found",
    errorTxt: "Error while loading repositories",
  },
};

export const repoPickerId = "repoPicker";

const RepositoryPicker = (props) => {
  const {
    onChange,
    onDismount,
    disabled,
    size = 12,
    clearOnUnmount,
    useCloud,
  } = props;
  const { dispatch, UI, warehouse, settings } = useUIBp();
  const { normalTxt, loadingTxt, emptyTxt, errorTxt, tooltip } =
    UIText[settings.locale];
  const { done, working, error } = useWorker(tunnelTokenId);
  const { repoPicker = { id: "" } } = UI;
  const { id } = repoPicker;
  const rootsData = useMemo(() => {
    return warehouse[rootsDataId] ?? [];
  }, [warehouse]);

  console.log("RepositoryPicker.js: rootsData", rootsData);

  const options = useMemo(() => {
    return [...rootsData]
      .sort((a, b) => sortObjByKey(a, b, "root"))
      .map((data) => {
        let size = data.size ? `${humanBytes(data.size)}` : "";
        return { label: useCloud?data.root+` [${size}]`:data.root, id: data.id? data.id : "NOID"+data.root };
      });
  }, [rootsData,useCloud]);

  // console.log("options", options);

  let label = normalTxt;
  if (done && !error && !options.length) {
    label = emptyTxt;
  } else if (done && error) {
    label = errorTxt;
  } else if (working) {
    label = loadingTxt;
  }

  // Cleanup
  useEffect(() => {
    return () => {
      if (clearOnUnmount) {
        dispatch(warehouseActions.unload(rootsDataId));
        dispatch(UIactions.clear(repoPickerId));
        dispatch(workerActions.clear(tunnelTokenId));
        if (onDismount) {
          onDismount();
        }
      }
    };
  }, [dispatch, onDismount, clearOnUnmount]);

  const handleChange = (e, value) => {
    // dispatch(UIactions.setValue({ id: userPickerId, value }));
    dispatch(UIactions.setValue({ id: repoPickerId, value }));
    if (onChange) {
      onChange(value);
    }
  };

  return (
    <Grid2 size={size}>
      <AutoHelp {...{ tooltip, disabled: disabled || working }}>
        <Autocomplete
          blurOnSelect
          disableClearable
          fullWidth
          {...{
            // disabled: (options.length > 0 ? false : true) || disabled,
            disabled: disabled,
            value: id ? repoPicker : null,
            filterOptions: AutocompleteFilter,
            onChange: handleChange,
            options,
            size: "small",
            loading: working,
            renderOption: (props, option) => {
              return (
                <li {...props} key={option.id}>
                  <Tooltip title={option.id} placement="right">
                    <Typography>{option.label}</Typography>
                  </Tooltip>
                </li>
              );
            },
            renderInput: (params) => {
              params.InputProps.startAdornment = (
                <InputAdornment position="start">
                  <Storage />
                </InputAdornment>
              );
              if (working) {
                params.InputProps.endAdornment = (
                  <InputAdornment position="end">
                    <CircularProgress size={14} />
                  </InputAdornment>
                );
              }
              return <TextField {...params} label={label} />;
            },
            isOptionEqualToValue: (option, value) => option.id === value.id,
          }}
        />
      </AutoHelp>
    </Grid2>
  );
};

export default RepositoryPicker;
